/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { FC } from 'react';
import styled from 'styled-components';
import { Avatar } from '../Avatar/Avatar';

const ListItemMetaElement = styled.div`
  display: flex;
  align-items: center;
`;

const AvatarElement = styled.div`
  margin-right: 20px;
`;

const ContentElement = styled.div<IProps>`
  word-break: break-all;
  .heading {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: ${({ description }) => (description ? '5px' : '0')};
    ${({ onHeadingClick }) => onHeadingClick && 'cursor: pointer;'}
  }
  .description {
    color: ${({ theme }) => theme.vars.newColor.darkGS2};
    ${({ heading }) => !heading && 'font-weight: 600;'}
  }
`;

interface IProps {
  /**
   * SVG icon for the avatar
   */
  avatarIcon?: string;
  /**
   * Image URL used to render an avatar image
   */
  avatarImage?: string;
  /**
   * Avatar background color
   */
  avatarBg?: string;
  /**
   * Heading of the meta
   */
  heading?: JSX.Element | string;
  /**
   * Heading tabindex number
   */
  headingTabIndex?: number;
  /**
   * Fires an event when the heading is clicked
   */
  onHeadingClick?: () => void;
  /**
   * Description of the meta
   */
  description?: JSX.Element | string;
}

export const ListItemMeta: FC<IProps> = props => (
  <ListItemMetaElement data-testid="ListItemMeta">
    {(props.avatarIcon || props.avatarImage) && (
      <AvatarElement>
        <Avatar icon={props.avatarIcon} image={props.avatarImage} bg={props.avatarBg} />
      </AvatarElement>
    )}
    {(props.heading || props.description) && (
      <ContentElement description={props.description} heading={props.heading}>
        {props.heading && (
          <h4
            className="heading"
            tabIndex={props.onHeadingClick ? props.headingTabIndex : null}
            onClick={props.onHeadingClick}
          >
            {props.heading}
          </h4>
        )}
        {props.description && <div className="description">{props.description}</div>}
      </ContentElement>
    )}
  </ListItemMetaElement>
);

ListItemMeta.defaultProps = { headingTabIndex: 0 };
